import loadable from '@loadable/component';

export const Promos = loadable(() => import(/* webpackChunkName: 'promos' */ './Promos'));
